interface PauseIconProps {
  size?: number;
  className?: string;
  /** Draws the bars inside a circle (the large FeedTile variant). */
  circle?: boolean;
}

/** Two vertical bars: "this feed is paused". */
const PauseIcon: React.FC<PauseIconProps> = ({ size = 16, className, circle }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    aria-hidden="true"
  >
    {circle
      ? <>
          <circle cx="8" cy="8" r="7" strokeWidth="1.2" />
          <path d="M6.3 5.3v5.4M9.7 5.3v5.4" strokeWidth="1.6" />
        </>
      : <path d="M5.5 3.5v9M10.5 3.5v9" strokeWidth="2.2" />}
  </svg>
);

export default PauseIcon;
